export default "__VITE_ASSET__CsZOPHY9__"